<div class="loader">
  <app-loader-element></app-loader-element>
</div>
